import { userData } from '@/types/types';

import { useAccountSettingsAdapter } from './AccountSettings.adapter';
import { AccountSettingsView } from './AccountSettings.view';

const AccountSettings = ({ userData }: { userData: userData }) => {
  const props = useAccountSettingsAdapter(userData);
  return <AccountSettingsView {...props} />;
};

export default AccountSettings;
